import type { FileTableColumnField, GatedFileTableColumnOptions } from '@/components/Views/Company/File/file-table.types';
import { FILE_TABLE_COLUMNS } from '@/components/Views/Company/File/file-table.types';
import { useFileTablePreferenceStore } from '@/stores/company/file-table-preference.store';
import { computed, toValue } from 'vue';

export const useFileTableColumns = (gatedColumns: GatedFileTableColumnOptions = {}) => {
    const fileTablePreferenceStore = useFileTablePreferenceStore();

    // any column not explicitly set to false is allowed
    const availableColumns = computed(() => FILE_TABLE_COLUMNS.filter(column => toValue(gatedColumns[column.field]) !== false));

    const visibleFields = computed<FileTableColumnField[]>({
        get() {
            return fileTablePreferenceStore.visibleFields;
        },
        set(fields) {
            fileTablePreferenceStore.visibleFields = fields;
        },
    });

    const visibleColumns = computed(() => availableColumns.value.filter(column => visibleFields.value.includes(column.field)));

    const isVisible = (field: FileTableColumnField) => visibleColumns.value.some(column => column.field === field);

    const isSortable = (field: FileTableColumnField) =>
        FILE_TABLE_COLUMNS.some(column => column.field === field && column.isSortable);

    return {
        availableColumns,
        visibleColumns,
        visibleFields,
        isVisible,
        isSortable,
    };
};
